import { FirestoreDoc } from '../commons/firestore/firestore-doc.model'

export class Notification extends FirestoreDoc {
	uid: string = ''
	data: string = ''
	createdAt: string = ''
	filterKeywords: Array<string> = ['']
}
